import React from 'react'

const fmt$ = (v) => v != null ? '$' + Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '—'
const fmt$0 = (v) => v != null ? '$' + Math.round(Number(v)).toLocaleString('en-US') : '—'
const fmtQty = (v) => Number(v || 0).toLocaleString('en-US')

const MaterialComparisonCard = ({ material, onSelectVendor }) => {
  const [expanded, setExpanded] = React.useState(true)
  const m = material
  const prices = m.vendorOptions.map(o => o.unitPrice).filter(p => p > 0)
  const minPrice = Math.min(...prices)
  const maxPrice = Math.max(...prices)
  const spread = minPrice > 0 ? Math.round(((maxPrice - minPrice) / minPrice) * 100) : 0

  const isSelected = (opt) =>
    m.selectedVendorQuoteId?.toString() === opt.vendorQuoteId?.toString() &&
    m.selectedVendorLineIdx === opt.vendorQuoteLineIdx

  return (
    <div className={`np-card${expanded ? ' open' : ''}`}>
      <div className="np-head" onClick={() => setExpanded(!expanded)}>
        <span className="np-chev">{expanded ? '▾' : '▸'}</span>
        <div className="mat-row-main">
          <div className="mat-row-title">
            <span className="mat-row-name">{m.canonicalName}</span>
            <span className="mat-row-meta">{m.category} · need {fmtQty(m.totalQty)} {m.unit}</span>
          </div>
          <div className="mat-row-sub">
            <span>{m.vendorOptions.length} vendors quoted</span>
            <span className="dot-sep">·</span>
            <span style={{ fontFamily: 'var(--f-mono)', fontVariantNumeric: 'tabular-nums' }}>{fmt$(minPrice)} – {fmt$(maxPrice)}</span>
            {spread > 0 && (
              <>
                <span className="dot-sep">·</span>
                <span>spread <b style={{ fontFamily: 'var(--f-mono)' }}>{spread}%</b></span>
              </>
            )}
          </div>
        </div>
        <div className="mat-row-right" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {m.status === 'needs_decision' && prices.length > 1 && (
            <button
              className="hmi-btn hmi-btn-outline hmi-btn-sm"
              onClick={e => {
                e.stopPropagation()
                const best = m.vendorOptions.reduce((a, b) => (b.unitPrice > 0 && b.unitPrice < a.unitPrice) || a.unitPrice <= 0 ? b : a)
                onSelectVendor(m._id, best.vendorQuoteId, best.vendorQuoteLineIdx)
              }}
            >
              Select cheapest
            </button>
          )}
          {m.status === 'needs_decision' && (
            <span className="mat-pill mat-pill--warn"><span className="mat-pill-dot" />Choose vendor</span>
          )}
          {m.status === 'vendor_selected' && (
            <span className="mat-pill mat-pill--ok"><span className="mat-pill-dot" />Selected</span>
          )}
        </div>
      </div>

      {expanded && (
        <div className="np-body">
          <div className="np-hdr-row">
            <span>Vendor</span>
            <span>SKU</span>
            <span>Unit price</span>
            <span>Extended</span>
            <span></span>
          </div>
          {m.vendorOptions.map((opt, i) => {
            const selected = isSelected(opt)
            const isBest = opt.unitPrice === minPrice && prices.length > 1
            const pctDiff = minPrice > 0 && opt.unitPrice > minPrice ? Math.round(((opt.unitPrice - minPrice) / minPrice) * 100) : 0
            const ext = opt.unitPrice * (m.totalQty || 0)

            return (
              <div
                key={i}
                className={`np-vendor-row${selected ? ' picked' : ''}`}
                onClick={() => onSelectVendor(m._id, opt.vendorQuoteId, opt.vendorQuoteLineIdx)}
              >
                <div className="np-vendor-name">
                  <span className={`np-radio${selected ? ' on' : ''}`}>{selected ? '✓' : ''}</span>
                  <div>
                    <b style={{ fontSize: 13 }}>{opt.vendor}</b>
                    {opt.vendorDescription && (
                      <div style={{ fontSize: 11, color: 'var(--ink-4)', fontWeight: 400, marginTop: 1, maxWidth: 320, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {opt.vendorDescription}
                      </div>
                    )}
                  </div>
                </div>
                <span className="np-sku">{opt.vendorSku || '—'}</span>
                <span className={`np-price${isBest ? ' best' : ''}${pctDiff > 0 ? ' worse' : ''}`}>
                  {fmt$(opt.unitPrice)}
                  <span style={{ color: 'var(--ink-4)', fontWeight: 400 }}> /{opt.uom || m.unit}</span>
                </span>
                <span className="np-ext">{fmt$0(ext)}</span>
                <div className="np-action">
                  {isBest && <span className="chip-mini chip-mini--ok">BEST</span>}
                  {pctDiff > 0 && <span className="chip-mini chip-mini--risk">+{pctDiff}%</span>}
                  <button
                    className={`hmi-btn hmi-btn-sm ${selected ? 'hmi-btn-primary' : 'hmi-btn-outline'}`}
                    onClick={e => { e.stopPropagation(); onSelectVendor(m._id, opt.vendorQuoteId, opt.vendorQuoteLineIdx) }}
                  >
                    {selected ? 'Picked' : 'Pick'}
                  </button>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default MaterialComparisonCard
